/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Nativelanguage_Tadschikisch2Inputs */

const en__field__enum_nativelanguage_tadschikisch2 = /** @type {(inputs: _Field__Enum_Nativelanguage_Tadschikisch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tadschikisch`)
};

const de__field__enum_nativelanguage_tadschikisch2 = /** @type {(inputs: _Field__Enum_Nativelanguage_Tadschikisch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tadschikisch`)
};

/**
* | output |
* | --- |
* | "Tadschikisch" |
*
* @param {_Field__Enum_Nativelanguage_Tadschikisch2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_nativelanguage_tadschikisch2 = /** @type {((inputs?: _Field__Enum_Nativelanguage_Tadschikisch2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Nativelanguage_Tadschikisch2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_nativelanguage_tadschikisch2(inputs)
	return de__field__enum_nativelanguage_tadschikisch2(inputs)
});
export { _field__enum_nativelanguage_tadschikisch2 as "_field__enum_nativeLanguage_Tadschikisch" }